export default {
  path: 'subscription',
  name: 'Subscription',
};
